<template>
  <lm-dropdown
    class="d-inline-block datatable-dropdowns"
    :value="optionsSelected"
    :data-items="options"
    :showToggleAll="showToggleAll"
    @input="onClick"
  >
    <button class="toggle text-nowrap">
      {{ label }}
      <span class="toggle-count" v-if="optionsSelectedCount">
        {{ optionsSelectedCount }}
      </span>
      <i class="dripicons dripicons-chevron-down"></i>
    </button>
  </lm-dropdown>
</template>

<script>
// Components
import LmDropdown from '@/components/LmDropdown'
import DropdownMenu from '@innologica/vue-dropdown-menu'

// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    label: String,
    optionsPath: String,
    pick: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    },
    showToggleAll: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LmDropdown,
    DropdownMenu
  },
  data () {
    return {
      show: false,
      search: '',
      options: []
    }
  },
  computed: {
    optionsSelectedCount () {
      return this.options.filter(el => el.selected).length
    },
    optionsSelected () {
      return this.options.filter(el => el.selected)
        .map(el => {
          return {
            id: el.id,
            name: el.name,
            value: el.value
          }
        })
    },
    optionsFiltered () {
      return this.options.filter(el => {
        return el.name.toLowerCase().search(this.search.toLowerCase()) >= 0
      })
    }
  },
  methods: {
    async loadOptions () {
      try {
        const res = await commonsApi.axiosGetWrapper(this.optionsPath)
        this.options = res.data.items.map(el => {
          return {
            ...el,
            selected: false
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    loadPickedOptions () {
      if (this.pick.length) {
        const picks = this.pick.map(el => el.id)
        this.options.forEach(el => {
          if (picks.includes(el.id)) {
            el.selected = true
          }
        })
      }
    },
    onClick (item) {
      if (!this.multiple) {
        this.options = this.options.map(el => {
          if (el.id !== item.id) el.selected = false
          return el
        })
      }
      item.selected = !item.selected
      this.$emit('change', this.optionsSelected)
    }
  },
  async created () {
    await this.loadOptions()
    await this.loadPickedOptions()
  }
}
</script>

<style lang="sass">
  .datatable-dropdowns
    .dropdown-menu
      margin-top: 5px
      padding: 0
    button.toggle
      display: flex
      gap: 5px !important
      background-color: #e9ecef
      border: 1px solid #ced4da !important
      padding: .3rem .7rem !important
      border-radius: 50px !important
      .toggle-count
        background-color: white
        color: #999
        font-size: 12px
        display: flex
        justify-content: center
        align-items: center
        width: 22px !important
        height: 22px !important
        border-radius: 50%
        align-self: center
        border: 1px solid #e1e1e1
</style>
